import React, { useEffect } from "react";
import { Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import useStore from "../../../store/useStore";
import OptimizedImage from "../../../commonComponents/OptimizedImage";
import useImagePreloader from "../../../hooks/useImagePreloader";

const Banner: React.FC<any> = ({ shots }) => {
  const navigate = useNavigate();
  const { tatvaShots } = useStore();
  const { userPreferences } = tatvaShots;

  // Preload banner images for better performance
  const shotUrls =
    shots
      ?.slice(0, 6)
      ?.map((item: any) => item.url)
      .filter(Boolean) || [];
  const { preloadImages } = useImagePreloader([], {
    priority: true,
    maxConcurrent: 6,
  });

  useEffect(() => {
    if (shotUrls.length > 0) {
      // Preload all banner images
      preloadImages(shotUrls);
    }
  }, [shotUrls.length]);

  const onBannerClick = (i: number) => {
    navigate("/short", {
      state: {
        type: "myFeed",
        currentShot: i,
      },
    });
  };

  return (
    <div className="w-full">
      <Carousel autoplay>
        {shots?.slice(0, 6)?.map((item: any, i: number) => (
          <div
            key={item.id}
            className="relative"
            onClick={() => onBannerClick(item.id)}
          >
            <OptimizedImage
              src={item.url}
              alt={item.title}
              className="w-full h-[300px] object-cover rounded-b-3xl"
              height="300px"
              loading={i === 0 ? "eager" : "lazy"}
              useIntersectionObserver={i > 2} // Load first 3 images immediately for carousel
              skeletonAnimation={true}
            />
            {/* Gradient overlay for better text visibility */}
            <div 
              className="absolute inset-0 rounded-b-3xl"
              style={{
                background: 'linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.20) 48.45%, rgba(0, 0, 0, 0.00) 100%)'
              }}
            ></div>
            <div className="absolute bottom-4 left-6 text-white text-left z-10">
              <span className="bg-white bg-opacity-95 py-1 px-3 rounded-lg text-[#625616] font-medium shadow-sm">
                {userPreferences?.find((pref) =>
                  item?.speciality?.some(
                    (s: any) => s.id === pref.speciality_id
                  )
                )?.code ||
                  item?.speciality?.[0]?.code ||
                  "General Medicine"}
              </span>
              <h2 className="mt-2 text-xl font-bold text-white drop-shadow-lg">
                {item?.title?.length > 70
                  ? `${item.title.substring(0, 70)}...`
                  : item.title}
              </h2>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Banner;
